import { render, staticRenderFns } from "./ModalDetailCertificate.vue?vue&type=template&id=20ecb5a3&"
import script from "./ModalDetailCertificate.vue?vue&type=script&lang=js&"
export * from "./ModalDetailCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports